import {
    initAccordion,
} from '@js/common/customFunctions.js';

initAccordion('.expandable-listing-section .els-list');
